import { useState, useRef, useEffect } from "react";
import { Palette, Check } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

const COLORS = [
  { key: "pink", label: "Pink", hex: "#FF1B6B" },
  { key: "blue", label: "Blue", hex: "#0040FF" },
  { key: "orange", label: "Orange", hex: "#FF6B1B" },
];

export default function AccentPicker({ size = 18, testId = "accent-picker" }) {
  const { accent, setAccent } = useTheme();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  const current = COLORS.find((c) => c.key === accent) || COLORS[0];

  return (
    <div className="relative" ref={wrapRef}>
      <button
        data-testid={testId}
        onClick={() => setOpen((v) => !v)}
        aria-label="Cambiar color de acento"
        title="Cambiar color de acento"
        className="p-2 rounded-full hover:opacity-70 transition relative"
        style={{ color: "var(--text)" }}
      >
        <Palette size={size} strokeWidth={2.2} />
        <span
          className="absolute bottom-1 right-1 w-2 h-2 rounded-full ring-1 ring-white/40"
          style={{ background: current.hex }}
        />
      </button>
      {open && (
        <div
          data-testid="accent-picker-menu"
          className="absolute right-0 mt-2 w-44 rounded-md border shadow-xl z-50 overflow-hidden"
          style={{ background: "var(--bg)", borderColor: "var(--border)" }}
        >
          <p className="px-3 pt-2.5 pb-1.5 text-[10px] font-bold uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>
            Color de acento
          </p>
          {COLORS.map((c) => {
            const active = c.key === accent;
            return (
              <button
                key={c.key}
                data-testid={`accent-option-${c.key}`}
                onClick={() => { setAccent(c.key); setOpen(false); }}
                className="w-full flex items-center gap-3 px-3 py-2.5 text-sm hover:bg-[color:var(--surface-2)] transition"
              >
                <span
                  className="w-5 h-5 rounded-full shrink-0 ring-2 ring-white/10"
                  style={{ background: c.hex }}
                />
                <span className="flex-1 text-left font-semibold">{c.label}</span>
                {active && <Check size={14} className="accent-text" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
